import ko = require("knockout");
import ChangeLogViewer = require("./changeLogViewer");

export class ChangeLogViewerRegistration {
    register() {
        console.log("registration in progress");

        ko.components.register("change-log-viewer", {
            viewModel: ChangeLogViewer.ChangeLogViewerViewModel,
            template: require("./changeLogViewer.html")
        });
    }
}
